import type {
  BillingProduct,
  BillingProductPrice,
} from "../types/billing";

export type UpgradePlan = {
  product: BillingProduct;
  price: BillingProductPrice;
};

export function getUpgradePlans(products: BillingProduct[]): UpgradePlan[] {
  return products.flatMap((product) =>
    product.prices
      .filter(
        (price) =>
          price.basePricePerMonth > 0 && Boolean(price.stripePriceId),
      )
      .map((price) => ({ product, price })),
  );
}

export function getCancellationPlan(
  products: BillingProduct[],
): UpgradePlan | null {
  for (const product of products) {
    if (product.isMagnusOpera) {
      continue;
    }

    const price = product.prices.find(
      (candidate) =>
        candidate.basePricePerMonth === 0 &&
        candidate.pricingModel === "fixed" &&
        !candidate.stripePriceId,
    );
    if (price) {
      return { product, price };
    }
  }

  return null;
}
